import { render, staticRenderFns } from "./e-joystick.vue?vue&type=template&id=05d6af6e&scoped=true"
import script from "./e-joystick.vue?vue&type=script&lang=js"
export * from "./e-joystick.vue?vue&type=script&lang=js"
import style0 from "./e-joystick.vue?vue&type=style&index=0&id=05d6af6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6af6e",
  null
  
)

export default component.exports